import { Button, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import CustomTextField from '../../components/common/CustomTextField'
import { useAppDispatch } from '../../hooks/reduxHooks'
import { UserManager } from '../../services/api/UserManager'
import { setAuthState } from '../../services/redux/auth/auth-actions'

import { AUTH_LOCAL_STORAGE_KEY, parseJwtEncodedTokenAndGetReduxState } from '../../services/redux/auth/auth-types'
import { displayMessage } from '../../services/redux/snackbar/snackbar-actions'
import { UserRole } from '../../services/api/sharedTypes/User'
import { RouteConstants } from '../../navigation/navigation-types'

const Login: React.FC = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    const [loadingData, setLoadingData] = useState<boolean>(false)
    const [userName, setUserName] = useState<string>('')
    const [password, setPassword] = useState<string>('')

    const handleLogin = async (username: string, password: string) => {
        try {
            setLoadingData(true)
            const login = await UserManager.getManager().authenticateAsync(username, password)
            if (login) {
                localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, login.token)
                const state = parseJwtEncodedTokenAndGetReduxState(login.token)
                dispatch(setAuthState(state))
                state.role === UserRole.User ? navigate(RouteConstants.events) : navigate(RouteConstants.home)
            }
        } catch (error) {
            setLoadingData(false)
            return dispatch(displayMessage({ message: 'Špatné přihlašovací údaje', type: 'error' }))
        }
        setLoadingData(false)
        dispatch(displayMessage({ message: 'Přihlášení proběhlo úspěšně', type: 'success' }))
    }

    return (
        <Stack alignItems='center' justifyContent='center' width='100%' height='100%'>
            <Stack
                p={3}
                width='80%'
                maxWidth={'840px'}
                direction={isMobile ? 'column' : 'row'}
                bgcolor={theme.palette.customBackground.default}
                alignItems='center'
                borderRadius={theme.shape.borderRadius}
                sx={{
                    boxShadow: theme.shadows[5],
                }}
            >
                <img src='https://happytimes.cz/wp-content/uploads/logo-2.png' alt='Happytimes logo' />
                <Stack width='100%' px={4} spacing={2}>
                    <Typography variant='h6'>Přihlášení</Typography>
                    <CustomTextField
                        autoComplete='on'
                        disabled={loadingData}
                        size='small'
                        label='Jméno'
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter' && !loadingData) {
                                handleLogin(userName, password)
                            }
                        }}
                    />
                    <CustomTextField
                        autoComplete='on'
                        disabled={loadingData}
                        size='small'
                        label='Heslo'
                        type='password'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter' && !loadingData) {
                                handleLogin(userName, password)
                            }
                        }}
                    />
                    <Button disabled={loadingData} variant='contained' onClick={() => handleLogin(userName, password)}>
                        Přihlásit se
                    </Button>
                </Stack>
            </Stack>
        </Stack>
    )
}

export default Login
